module.exports = {"errors":{"fetch":{"curriculum":"Kon het leerplan niet ophalen"}},"search":{"error":"Er ging iets fout tijdens het zoeken","errorTerms":"Kon begrippen niet ophalen"}}


//////////////////
// WEBPACK FOOTER
// ./web/resource/dutch.json
// module id = 1242
// module chunks = 0